require('./brokerMyInvestments.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { connect } = require('react-redux');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @actions
const myWalletAction = require('actions/myWallet');
const { setSelectedView } = require('actions/brokerMyInvestmentWidget');
const { setActiveTab } = require('actions/myWallet');
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');

// @components
const BrokerMyInvestmentsProducts = require('./brokerMyInvestmentsProducts/brokerMyInvestmentsProducts');
const BrokerMyInvestmentsContracts = require('./brokerMyInvestmentsContracts/brokerMyInvestmentsContracts');
const BrokerMyInvestmentsActivos = require('components/broker/myInvestments/brokerMyInvestmentsActivos/brokerMyInvestmentsActivos');

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { BoxTabs } = require('commonsComponents/boxTabs');
const { OKLink } = require('commonsComponents/OKLink');
const { isEmpty } = require('lodash');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

// @constants
const {
    ASSET_ACTIVE_TAB, HYPHEN,
    PRODUTCS_ACTIVE_TAB,
    MYPROFILE_BROKER_EXPLORE,
    BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME
} = require('constants/index');
const {
    NOT_SELECTED_PRODUCTS_TAB_BROKER,
} = require('constants/flagBasedFeatures');
import { WEALTH_CRYPTO } from 'constants/flagBasedMBFeatures';


// @utilities
const { recordLinkV2 } = require('utilities/tagging');

class BrokerMyInvestments extends React.Component {
    constructor(props) {
        super(props);
        this.handleRetry = this.handleRetry.bind(this);
        this.handlePillClick = this.handlePillClick.bind(this);
        this.onTabChange = this.onTabChange.bind(this);
        this.getSelectedViewContent = this.getSelectedViewContent.bind(this);
    }

    componentDidMount() {
        const { getStocksContracts, flagBasedFeatures } = this.props
        getStocksContracts();
        if(!flagBasedFeatures.get(NOT_SELECTED_PRODUCTS_TAB_BROKER)) this.onTabChange(1)
    }

    buildEmptyState(productTabTitle) {
        const startToInvestButton = (
            <div className="broker-my-investments__start-to-invest-container">
                <OKButton
                    modifier="secondary"
                    to={MYPROFILE_BROKER_EXPLORE} >
                    {formatText('broker-miCarteraEmptyStateCTALabel')}
                </OKButton>
            </div>
        );
        return (
            <ContentBox customClassName="broker-my-investments">
                <div className="broker-my-investments__title">
                    <span>{productTabTitle}</span>
                </div>
                <EmptyState
                    primaryText={formatText('broker-myInvestmentsEmptyState')}
                    button={startToInvestButton}
                    iconType="search-wealth" />
            </ContentBox>
        );
    }

    buildErrorState(productTabTitle) {
        const lostConnectionFirstLine = formatText('broker-lostConnectionFirstLine');
        const retryButton = (
            <OKButton id="btn_accountLastMovements_retry" onClick={this.handleRetry}>
                <FormattedText value="broker-retry" />
            </OKButton>
        );
        return (
            <ContentBox customClassName="broker-my-investments">
                <div className="broker-my-investments__title">
                    <span>{productTabTitle}</span>
                </div>
                <EmptyState button={retryButton} primaryText={lostConnectionFirstLine} iconType="nointernet-wealth"/>
            </ContentBox>
        );
    }

    buildLoadingState(productTabTitle) {
        return (
            <ContentBox customClassName="broker-my-investments">
                <div className="broker-my-investments__title">
                    <span>{productTabTitle}</span>
                </div>
                <LoadingSection />
            </ContentBox>
        );
    }

    checkIfEmpty() {
        const { immStocksByType } = this.props;
        const noETFs = !immStocksByType.get('etfs');
        const noFunds = !immStocksByType.get('funds');
        const noStocks = !immStocksByType.get('stocks');
        const noPlans = !immStocksByType.get('plans');
        const noWarrants = !immStocksByType.get('warrants');
        const noFutures = !immStocksByType.get('futures');

        return noETFs && noFutures && noFunds && noPlans && noWarrants && noStocks;
    }

    handleRetry() {
        if (this.props.onHandleRetry) {
            this.props.onHandleRetry();
        }
        this.props.getStocksContracts();
    }

    handlePillClick(activeTab) {
        this.props.setSelectedView(activeTab);
    }

    getSelectedViewContent() {
        const {
            immAccounts,
            immBrokerMyInvestments,
            immStocksByType,
            immFundsContributionsList,
            immStocksByContract,
            immMyWalletCharts,
            getStocksByContract,
            isFetchingStocksByContract,
            isFetchingStocksByType,
            postWalletAlias,
            setOperationContractValue,
            setOrdersAndMovementsContract,
            onInternalTransferFundsClick,
            onOpenTraderClick,
            getContractState,
            immBrokerContractState,
            setOrdersAndMovementsAccessFrom,
            flagBasedFeatures,
            flagBasedMBFeatures
        } = this.props;
        const totalInvestment = immBrokerMyInvestments.getIn(['totalSummarizedValues', 'summarizedInvestedCap']);
        const totalValue = immBrokerMyInvestments.getIn(['totalSummarizedValues', 'summarizedValor']);
        const totalEarnings = immBrokerMyInvestments.getIn(['totalSummarizedValues', 'summarizedProfitability']);
        const totalEarningsPercentage = immBrokerMyInvestments.getIn(['totalSummarizedValues', 'profitablePercentage']);
        const fetchingCustomWallet = immMyWalletCharts.get('isFetching') || immMyWalletCharts.getIn(['defaultView','isFetching']);
        const fetchingStocksByType = immBrokerMyInvestments.get('isFetching') || fetchingCustomWallet;
        const activeTab = immMyWalletCharts.get('activeTab');
        const isCryptoNfeFeatureEnabled = flagBasedMBFeatures.get(WEALTH_CRYPTO);
        const immStocksNotEmptyContracts = immBrokerMyInvestments.get('contracts').filter((immContract) => {
            const isEmpty = !immContract.get('elements').size;
            return !isEmpty;
        });

        if (activeTab == PRODUTCS_ACTIVE_TAB) {
            return (
                <BrokerMyInvestmentsProducts
                    immStocksByType={immStocksByType}
                    immFundsContributionsList={immFundsContributionsList}
                    isFetchingStocksByType={isFetchingStocksByType}
                    totalInvestment={totalInvestment}
                    totalValue={totalValue}
                    totalEarnings={totalEarnings}
                    totalEarningsPercentage={totalEarningsPercentage}
                    onOpenTraderClick={onOpenTraderClick}
                    setOrdersAndMovementsAccessFrom={setOrdersAndMovementsAccessFrom}
                    immMyWalletCharts={immMyWalletCharts}
                    onHandleBuyClick={this.props.onHandleBuyClick}
                    resetSpecificProduct={this.props.resetSpecificProduct}
                    pageName={this.props.pageName}
                />
            );
        } else if (activeTab == ASSET_ACTIVE_TAB) {
            return (
                <BrokerMyInvestmentsActivos
                    isFetchingStocksByType={fetchingStocksByType}
                    immFeatureFlag={flagBasedFeatures}
                    totalInvestment={totalInvestment}
                    totalValue={totalValue}
                    totalEarnings={totalEarnings}
                    totalEarningsPercentage={totalEarningsPercentage}
                    onOpenTraderClick={this.props.onOpenTraderClick}
                    displayLegend={true}
                    displayActivosDigitales={isCryptoNfeFeatureEnabled}
                    setOrdersAndMovementsAccessFrom={this.props.setOrdersAndMovementsAccessFrom}
                    immMyWalletCharts={this.props.immMyWalletCharts}
                    onHandleBuyClick={this.props.onHandleBuyClick}
                    immBrokerMyInvestments={immBrokerMyInvestments}
                    onPreSelectOriginInternalTransferFund={this.props.onPreSelectOriginInternalTransferFund}
                    setSellContract={this.props.setSellContract}
                    pageName={this.props.pageName}
                />
            );
        } else {
            return (
                <BrokerMyInvestmentsContracts
                    immAccounts={immAccounts}
                    getStocksByContract={getStocksByContract}
                    immBrokerContractState={immBrokerContractState}
                    getContractState={getContractState}
                    immStocksByContract={immStocksByContract}
                    immStocksContracts={immStocksNotEmptyContracts}
                    immStocksByType={immStocksByType}
                    totalInvestment={totalInvestment}
                    isFetchingStocksByContract={isFetchingStocksByContract}
                    postWalletAlias={postWalletAlias}
                    totalValue={totalValue}
                    totalEarnings={totalEarnings}
                    totalEarningsPercentage={totalEarningsPercentage}
                    setOperationContractValue={setOperationContractValue}
                    setOrdersAndMovementsContract={setOrdersAndMovementsContract}
                    onInternalTransferFundsClick={onInternalTransferFundsClick}
                    onOpenTraderClick={onOpenTraderClick}
                    immMyWalletCharts={immMyWalletCharts}
                    onHandleBuyClick={this.props.onHandleBuyClick}
                    pageName={this.props.pageName}
                />
            );
        }
    }

    onTabChange(value) {
        this.props.setActiveTab(value);
    }

    calculateData(showModalFunc) {
        const showCalculationData = {
            categoriaEvento: 'myPortfolioHomeInteraction',
            accionEvento: 'productsCard',
            etiquetaEvento: 'dataCalculation'
        }
        recordLinkV2(showCalculationData);
        showModalFunc();
    }

    render() {
        const {
            immMyWalletCharts,
            isFetchingStocksByType,
            isFetchingMyInvestment,
            brokerMyInvestmentsErrorReceived,
            immBrokerMyInvestments
        } = this.props;

        const activeTab = immMyWalletCharts.get('activeTab');
        let contractTabDisable = false;
        let tabTitle, selectedActiveTab;
        const immStocksNotEmptyContracts = immBrokerMyInvestments.get('contracts').filter((immContract) => {
            const isEmpty = !immContract.get('elements').size;
            return !isEmpty;
        });

        if (isEmpty(immStocksNotEmptyContracts.toJS())) {
            contractTabDisable = true;
        }

        if (activeTab == PRODUTCS_ACTIVE_TAB) {
            tabTitle = formatText('broker-productTitle');
            selectedActiveTab = true;
        } else if (activeTab == ASSET_ACTIVE_TAB) {
            tabTitle = formatText('broker-activosTitle');
        } else {
            tabTitle = formatText('broker-contractTitle');
        }
        const language = getLanguage();
        let selectedViewTitle = immMyWalletCharts.get('selectedView','');

        if(selectedViewTitle ===  BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME) {
            if(language === 'nl') {
                selectedViewTitle = " ";
            } else {
                selectedViewTitle = formatText('broker-total');
            }
        }
        const vista = formatText('broker-vista');
        selectedViewTitle = selectedViewTitle ? ` ${HYPHEN} ${vista} ${selectedViewTitle}`: '';

        if (brokerMyInvestmentsErrorReceived) {
            return this.buildErrorState(tabTitle);
        }

        if (isFetchingStocksByType || isFetchingMyInvestment) {
            return this.buildLoadingState(tabTitle);
        }

        if (this.checkIfEmpty()) {
            return this.buildEmptyState(tabTitle);
        }

        const getSelectedViewContent = this.getSelectedViewContent();

        return (
            <div>
                <div className="broker-my-investments__wrapper broker-my-investments__tabtitle-container">
                    <div className="broker-my-investments__title">
                        <span>{tabTitle}</span>
                        <span className="broker-my-investments__subtitle">{selectedViewTitle}</span>
                        <div>
                            <OKLink
                                modifier="emphasize"
                                onClick={() => this.calculateData(this.props.onToggleModal)}
                            >
                                <FormattedText value="brokerCalculateMyWalletModal-link" />
                            </OKLink>
                        </div>
                    </div>
                    <div className="broker-my-investments__pill">
                        <BoxTabs
                            tabs={[
                                formatText('broker-myWalletProducts'),
                                formatText('broker-myWalletClassDeActivo'),
                                formatText('broker-myWalletClassContracts')
                            ]}
                            activeTab={activeTab}
                            handleSelectedTab={this.onTabChange}
                            defaultTabIndex={activeTab}
                            tabsAsPills={true}
                            selectedActiveTab={selectedActiveTab}
                            tabDisabled={[false, false, contractTabDisable]}
                        />
                    </div>
                </div>
                <div className="col-md-14">
                    {getSelectedViewContent}
                </div>
            </div>);
    }
}

BrokerMyInvestments.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immBrokerMyInvestmentWidget: PropTypes.object.isRequired,
    immStocksByType: PropTypes.object,
    immStocksByContract: PropTypes.object,
    onHandleRetry: PropTypes.func,
    getStocksContracts: PropTypes.func,
    getStocksByContract: PropTypes.func,
    isFetchingStocksByContract: PropTypes.bool,
    isFetchingStocksByType: PropTypes.bool,
    isFetchingMyInvestment: PropTypes.bool,
    brokerMyInvestmentsErrorReceived: PropTypes.bool,
    postWalletAlias: PropTypes.func,
    setActiveTab: PropTypes.func,
    setOperationContractValue: PropTypes.func.isRequired,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    immMyWalletCharts: PropTypes.object.isRequired,
    onInternalTransferFundsClick: PropTypes.func.isRequired,
    onToggleModal: PropTypes.func.isRequired,
    getContractState: PropTypes.func,
    immBrokerContractState: PropTypes.object,
    onOpenTraderClick: PropTypes.func,
    onHandleBuyClick: PropTypes.func,
    onPreSelectOriginInternalTransferFund: PropTypes.func.isRequired,
    resetSpecificProduct: PropTypes.func.isRequired,
    setSellContract: PropTypes.func.isRequired,
    setSelectedView: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    flagBasedMBFeatures: PropTypes.object.isRequired,
    pageName: PropTypes.string
};

module.exports.constructor = BrokerMyInvestments;
module.exports.BrokerMyInvestments = connect(
    state => ({
        immBrokerMyInvestmentWidget: state.brokerMyInvestmentWidget,
    }),
    {
        onToggleModal: myWalletAction.toggleModal,
        resetSpecificProduct: BrokerProductFiltersSearchActions.resetSpecificProduct,
        setSelectedView,
        setActiveTab: setActiveTab,
    }
)(withFeatureToggling(BrokerMyInvestments));
